import React, { useEffect, useState } from "react";
import "./../../assets/styles/Style.css";
import { NavMenu } from "./NavMenu";
import { useNavigate } from "react-router-dom";
import { useLocation} from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faMobile, faMobileAlt, faRefresh, faUserAlt, faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import '../../assets/styles/Login.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import KrishiMapperlogo from '../../assets/images/krishiMapper.png';
import agricultureDarkLogo from '../../assets/images/agriculture-logo-dark.png';
import { Link } from "react-router-dom";
// import showPwdImg from '../../assets/images/show-eye.svg';
// import hidePwdImg from '../../assets/images/hide-eye.svg';
let loginDetails = {};


function MapLogin(props) {
  // const [pwd, setPwd] = useState('');
  // const [isRevealPwd, setIsRevealPwd] = useState(false);
  let location = useLocation();
  location.state ? console.log("true") : console.log("false");

  const [isLoading, setIsLoading] = useState(false); 

  const [captchaTexts, setCaptchaTexts] = useState(''); 
  const [userInput, setUserInput] = useState(''); 

  console.log("propsss",location.state);
    const navigate = useNavigate();
    let captchaText;
    let userText;
    var code;
    let output = document.querySelector('#output');;
    let refreshButton;
    let alphaNums = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      

   

    let loginCount = 0;
    const [schemeValue, setSchemeValue] = useState(""); 
    const [passwordShown, setPasswordShown] = useState(false);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    

    useEffect(() => {
      localStorage.removeItem("username");
        //  captchaText = document.querySelector('#captcha');    
         userText = document.querySelector('#textBox');
        let submitButton = document.querySelector('#login_btn');
      
        refreshButton = document.querySelector('#refresh');
          let emptyArr = [];
        for (let i = 1; i <= 6; i++) {
            emptyArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
        }
         captchaText = emptyArr.join('');
         setCaptchaTexts(captchaText)
       
        // Draw canvas   
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 100;
        canv.height = 35;
        var ctx = canv.getContext("2d");
        ctx.font = "20px arial";
         ctx.top = "20px";
        ctx.color ="#008957"
        ctx.strokeText(emptyArr.join(""), 0, 30);
        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        code = emptyArr.join("");
        document.getElementById("captcha").replaceWith(canv);          
    }, [])


    function RefreshButton() {
            // userText.value = "";
            setUserInput("")
            let refreshArr = [];
            for (let j = 1; j <= 6; j++) {
                refreshArr.push(alphaNums[Math.floor(Math.random() * alphaNums.length)]);
            }
             captchaText = refreshArr.join('');
             setCaptchaTexts(captchaText)
             output.innerHTML = "";
            var canv = document.createElement("canvas");
            canv.id = "captcha";
            canv.width = 100;
            canv.height = 35;
            var ctx = canv.getContext("2d");
            ctx.font = "20px arial";
             ctx.top = "20px";
            ctx.color ="#008957"      
            ctx.strokeText(refreshArr.join(""), 0, 30);
            //storing captcha so that can validate you can save it somewhere else according to your specific requirements
            code = refreshArr.join("");      
            document.getElementById("captcha").replaceWith(canv);  
    }




    function LoginCropic() {
      
        // localStorage.setItem("username", String(document.getElementById("yourUsername").value))
        localStorage.setItem("usertype", "admin")
        let outputCred = document.querySelector('#outputCred');
        let output = document.querySelector('#output');
        setIsLoading(true); 

    
        const asyncPostCall = async () => {
        try {
            localStorage.setItem(userName, loginCount);
            const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth/PasswordAuth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "userid": userName,
                    "Password": password
                })
            });

            const data = await response.json();
            loginDetails = data.dataContent[0];

            if (data.success) {
                outputCred.innerHTML = '';
            } else {
                localStorage.setItem(userName, ++loginCount);
                outputCred.innerHTML = "Invalid Credential, please try again";
                RefreshButton();
            }

            if (captchaTexts === userInput) {
                output.innerHTML = '';
            } else {
                RefreshButton();
                output.innerHTML = "Incorrect Captcha, please try again";
            }

            if (data.success === false) {
                alert(data.message);
            }

            if (data.success && captchaTexts === userInput && data.dataContent[0].isActive === "Yes") {
                localStorage.setItem("userCodeGlobal", data.dataContent[0].userCode);
                localStorage.setItem("username", data.dataContent[0].userName);
                APICallforuserRoleCode(data.dataContent[0].userCode);
            }

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false); 
        }
    };
        asyncPostCall()  
        
    }

    async function APICallforuserRoleCode(localUserCodeValue) {
        const response = await fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users/getUsersExt`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "userCode": localUserCodeValue
              })
        });
        const datausercode = await response.json();
      
        let localData= datausercode.dataContent[0]
        localStorage.removeItem("userRoleCode") 
        localStorage.removeItem("schemeCode")
        localStorage.setItem("userRoleCode", localData.userRoleCode)
        localStorage.setItem("schemeCode", localData.schemeCode)
        sessionStorage.setItem("userRoleName", localData.userRoleName)
        sessionStorage.setItem("departmentName", localData.deptName)
        sessionStorage.setItem("designationName", localData.desigName)
        sessionStorage.setItem("user", true)

        sessionStorage.setItem("userTypeCodeGlobal", localData.userTypeCode) 
        sessionStorage.setItem("orgTypeCodeGlobal", localData.orgTypeCode)  
        sessionStorage.setItem("stateNameGlobal", localData.stateCode)  
        sessionStorage.setItem("districtCodeGlobal", localData.districtCode)  
        sessionStorage.setItem("blockCodeGlobal", localData.blockCode) 


        location.state  ? navigate("/gisdashboard") : navigate("/gisdashboard", {state: { userRoleCodeState : localData.userRoleCode, schemeCodeState : localData.schemeCode}})
    }

  
    function handleLogin(event) {
      setUserInput(event.target.value)
        document.getElementById("output").innerHTML = '';
        document.getElementById("outputCred").innerHTML = '';
            if (event.keyCode === 13) {
                LoginCropic();
            }
    }




  function generateOTP() {

    var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

var raw = JSON.stringify({
  "mobileno": String(document.getElementById("MobileNumber").value) 
});

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  body: raw,
  redirect: 'follow'
};

fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/otpauth`, requestOptions)
  .then(response => response.json())
  .then(result => alert(result.message))
  .catch(error => console.log('error', error));
  }

  const handleToggle = () => {
    // if (type==='password'){
    //    setIcon(faEye);
    //    setType('text')
    // } else {
    //    setIcon(faEyeSlash)
    //    setType('password')
    // }
    setPasswordShown(passwordShown ? false : true);
 }

    return (
      <>

<main className="main_back">
        <div className="container">
          <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center">
            <div className="container">
            <div className="backhome">
              <Link to="/" className="btn btn-success w-100 ">Back To Home</Link>
             </div>
              <div className="row justify-content-center">
                <div className="col-md-4 card">
                  <div className="row">
                    {/* <div className="col-lg-6 padding_zero leftLoginimgs">
                      <div className="d-flex justify-content-center">
                        <Link to="/" className="backToHome">Back To Home</Link>
                      </div>
                    </div>  */}

                    <div className="col-lg-12 login_box">
                      <div className="card-body">
                        
                      <div className="col-md-12">
                            <div className="row">
                          <div className="col-md-2"><img src={agricultureDarkLogo} alt="agriculture government of india" className="agriculture-logo" /></div>
                          <div className="col-md-10 px-0">   <Link to="/" > <img src={KrishiMapperlogo} alt="Krishi Mapper Logo" className="loginKLogo" /> </Link>
                          <h5 className="text-center pb-0 fs-4">
                          Login to Your Account
                        </h5>
                          </div>
                          </div>
                          </div>




                        <div className="row justify-content-center">
                        <div className="col-12">
                                <div className="input-group">
                                  <label>User Id</label>
                                  <div className="input-group has-validation">
                                    <span className="input-group-text">
                                      <i>
                                        <FontAwesomeIcon icon={faUserAlt} />
                                      </i>{" "}
                                    </span>
                                    <input
                                      type="text"
                                      min="10"
                                      max="12"
                                      placeholder="Username"
                                      name="username"
                                      className="form-control"
                                      id="yourUsername"
                                      required
                                    
                                      onKeyUp={(e) => setUserName(e.target.value)}
                                    />
                                    <div className="invalid-feedback">
                                      Please enter your Mobile no.
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-12">
                                <label> Password </label>
                                <div className="input-group has-validation">
                                  <span className="input-group-text">
                                    <i>
                                      <FontAwesomeIcon icon={faKey} />
                                    </i>{" "}
                                  </span>
                                  <input
                                     type={passwordShown ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    placeholder="Password"
                                    id="yourPassword"
                                    onKeyUp={(e) => setPassword(e.target.value)}
                                    required
                                    
                                  />
                                           <i class="flex justify-around items-center showhidebtns"  onClick={handleToggle}>
                                      <FontAwesomeIcon icon={passwordShown ? faEyeSlash : faEye} />
                                    </i>{" "}
                                  {/* <div className="input-group-append">
                                    <span onclick="password_show_hide();">
                                      <i
                                        className="fas fa-eye"
                                        id="show_eye"
                                      ></i>
                                      <i
                                        className="fas fa-eye-slash d-none"
                                        id="hide_eye"
                                      ></i>
                                    </span>
                                  </div> */}
                                </div>
                                {/* <div className="input-group has-validation pwd-container">
                                  <span className="input-group-text">
                                    <i>
                                      <FontAwesomeIcon icon={faKey} />
                                    </i>{" "}
                                  </span>
                                  <input
                                    type={isRevealPwd ? "text" : "password"}
                                    name="password"
                                    className="form-control"
                                    placeholder="Password"
                                    id="yourPassword"
                                    onChange={e => setPwd(e.target.value)}
                                    onKeyUp={(e) => handleLogin(e)}
                                    required          
                                  />
                                 <img
          title={isRevealPwd ? "Hide password" : "Show password"}
          src={isRevealPwd ? hidePwdImg : showPwdImg}
          onClick={() => setIsRevealPwd(prevState => !prevState)}
        />
                                </div> */}
                                <span
                                  id="outputCred"
                                  className="redText"
                                ></span>
                                <div className="invalid-feedback">
                                  {" "}
                                  Please enter your OTP!
                                </div>
                              </div>

                              <div className="col-12">
                                <label>Enter Captcha</label>
                                <div id="captchaBackground">
                                  <strong>
                                    <span id="captcha"></span>
                                  </strong>
                                  <strong>
                                    <input
                                      id="textBox"
                                      type="text"
                                      name="text"
                                      placeholder="Captcha"
                                      required
                                      onKeyUp={(e) => handleLogin(e)}
                                    />
                                  </strong>
                                  <strong>
                                    <FontAwesomeIcon
                                      id="refresh"
                                      icon={faRefresh}
                                      onClick={RefreshButton}
                                    ></FontAwesomeIcon>
                                  </strong>
                                </div>
                                <span id="output" className="redText"></span>
                              </div>

                              <div className="col-12">
                               <button
                                  className="btn btn-success w-100"
                                  onClick={LoginCropic}
                                  id="login_btn"
                                  disabled={isLoading} // Disable button when loading
                                >
                                  {isLoading ? <i className="spinner-border spinner-border-sm">  </i> :   <i className="bi bi-globe-americas"></i>}       
                                  {isLoading ? " Logging in..." : "Login"}
                                </button>


                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/* <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India.
            </a>
          </div>
        </footer> */}
      </main>
      </>
    );
}

export {
  MapLogin,
    loginDetails,
}